import { AuthDispatchProps } from "./auth.props";

const authState: AuthDispatchProps = {
  isLoggedIn: false,
  token: "",
  user: "",
  rol: [],
  dispatch: () => null,
};

export default authState;
